import { DisponibilidadHoraria } from '../../domain/entities/DisponibilidadHoraria';
import { DisponibilidadHorariaRepository } from '../../domain/repositories/DisponibilidadHorariaRepository';

export class DisponibilidadHorariaService {
  constructor(private repositorio: DisponibilidadHorariaRepository) {}

  async validar(fecha: string): Promise<DisponibilidadHoraria> {
    return this.repositorio.validarDiaHabil(fecha);
  }
}
